var NumberUtil = (function () {
    function NumberUtil() {
    }
    NumberUtil.formatMoney = function (value, withCents) {
        if (withCents === void 0) { withCents = true; }
        var val = Number(value);
        var formatted = withCents ? val.toFixed(2) : Math.ceil(val).toString();
        return "$".concat(formatted);
    };
    NumberUtil.format = function (value) {
        return Number(value).toLocaleString("en");
    };
    return NumberUtil;
}());
export default NumberUtil;
//# sourceMappingURL=NumberUtil.js.map